export default __webpack_public_path__ + "static/media/Thug's Boots of Charred Earth.287488bb.jpg";